import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import moment from 'moment-timezone';

import { actions } from './redux/actions';
import '../Widgets.scss';
import Strings from '../../../../Strings';

function PatientsWithNewNotes(props) {
  const { orgId, days, getData, refreshTimestamp } = props;

  const endTimestamp = moment().format();
  const startTimestamp = moment()
    .subtract(days, 'day')
    .format();

  React.useEffect(() => {
    getData(startTimestamp, endTimestamp, orgId);
  }, [days, orgId, refreshTimestamp]);

  const { isLoading, patientsWithNewNotes } = props;
  return (
    <React.Fragment>
      {!isLoading && (
        <div className="boxWithVl-box">
          <div className="boxWithVl-valueBox black">{patientsWithNewNotes}</div>
          <div
            onClick={() => props.onClick(`/cap-patients/list?filters=["NewNotesSince:${days}"]`)}
            className="boxWithVl-labelBox clickable"
            data-tooltip-content={Strings.formatString(Strings.widgetsTooltips.inTheLastXDays, days)}
            data-tooltip-id="tooltip"
          >
            {Strings.widgets.patientsWithNewNotes}
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

PatientsWithNewNotes.widgetId = 'PatientsWithNewNotesWidget';

PatientsWithNewNotes.propTypes = {
  getData: PropTypes.func,
  patientsWithNewNotes: PropTypes.any,
  isLoading: PropTypes.any,
  onClick: PropTypes.func,
  dashboardId: PropTypes.string,
  days: PropTypes.number,
  orgId: PropTypes.string,
  refreshTimestamp: PropTypes.number,
};

const mapStateToProps = state => {
  const { widgetPatientsWithNewNotesReducer } = state.dashboardWidgets;

  return {
    patientsWithNewNotes: widgetPatientsWithNewNotesReducer && widgetPatientsWithNewNotesReducer?.patientsWithNewNotes,
    isLoading: widgetPatientsWithNewNotesReducer && widgetPatientsWithNewNotesReducer?.isLoading,
    orgId: state.entities?.orgFilter?.orgId,
  };
};

const mapDispatchToProps = dispatch => ({
  getData: (startTimestamp, endTimestamp, orgId) => dispatch(actions.getPatientsWithNewNotes(startTimestamp, endTimestamp, orgId)),
  onClick: path => dispatch(push(path)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PatientsWithNewNotes);
